import type { CardCopy, Cost } from '../types/cards';
import type { Effect } from '../types/effects';
import type { Age, Color, Resource, ResourceCount, ScienceSymbol } from '../types/resources';
import { RESOURCE_LETTERS } from '../types/resources';

/** Recursos en notación compacta: `'WWO'` → `{ wood: 2, ore: 1 }`. */
export function res(letters: string): ResourceCount {
  const out: ResourceCount = {};
  for (const ch of letters) {
    const r = RESOURCE_LETTERS[ch];
    if (!r) throw new Error(`Letra de recurso desconocida: ${ch}`);
    out[r] = (out[r] ?? 0) + 1;
  }
  return out;
}

/** Coste: `''` gratis, `'1$'` una moneda, `'WWO'` recursos. */
export function cost(spec: string): Cost {
  if (spec === '') return {};
  const m = /^(\d+)\$$/.exec(spec);
  if (m) return { coins: Number(m[1]) };
  return { resources: res(spec) };
}

export function letters(spec: string): Resource[] {
  return [...spec].map((ch) => {
    const r = RESOURCE_LETTERS[ch];
    if (!r) throw new Error(`Letra de recurso desconocida: ${ch}`);
    return r;
  });
}

/** Produce los recursos listados (cada letra una unidad). */
export const produce = (spec: string): Effect => ({ kind: 'produce', resources: letters(spec) });
/** Produce UNO de los recursos listados. */
export const produceOne = (spec: string): Effect => ({ kind: 'produce', resources: letters(spec), choice: true });
export const vp = (amount: number): Effect => ({ kind: 'vp', amount });
export const coins = (amount: number): Effect => ({ kind: 'coins', amount });
export const shields = (amount: number): Effect => ({ kind: 'shields', amount });
export const science = (symbol: ScienceSymbol): Effect => ({ kind: 'science', symbol });

export const neighborsCards = (colors: Color[]) => ({ kind: 'cards' as const, colors });

/** Copias de una carta en una era: `copies(1, 3, 4)` → 3+ y 4+. */
export function copies(age: Age, ...mins: CardCopy['minPlayers'][]): CardCopy[] {
  return mins.map((minPlayers) => ({ age, minPlayers }));
}
